import { Box, AppBar, Toolbar, Autocomplete, TextField, IconButton, Icon } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAuth } from "auth/authProvider";
import { useCustomerValue } from "providers/CustomerContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useMaterialUIController, setMiniSidenav } from "context";

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#7586dd",
    },
  },
});

function Navbar() {
  const location=useLocation()
  const navigate=useNavigate()
  const [controller, dispatch] = useMaterialUIController()
  const { miniSidenav } = controller
  const{pathname}=location
  const path=pathname.split("/")
  let pathName2=path[2]
  if(pathName2==="vendor-sku"||pathName2==="sku-pack-type"){
    pathName2="sku"
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        color="default"
        position="static"
        //sx={{ borderRadius: "2px", backgroundColor: "#e6eaf9" }}
        sx={{ borderRadius: "2px", backgroundColor: "#f0f2f5",boxShadow:"0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.02), 0px 1px 10px 0px rgba(0,0,0,0.2)" }}
      >
        <Toolbar>
          <IconButton onClick={() => setMiniSidenav(dispatch, !miniSidenav)}>
            <Icon fontSize="large">{miniSidenav ? "menu" : "menu_open"}</Icon>
          </IconButton>
          <IconButton onClick={()=>navigate(`/${path[1]}/${pathName2}`)}>
            <Icon fontSize="large">
              chevron_left
            </Icon>
            Back
          </IconButton>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Select />
        </Toolbar>
      </AppBar>
    </Box>
  );
}

const Select = () => {
  const { customerCode, setCustomerCode, customerOpt } = useCustomerValue();
  const {switchCustomer} = useAuth()
  const location=useLocation()
  const navigate=useNavigate()
  const{pathname}=location
  const path=pathname.split("/")
  let pathName2=path[2]
  return (
    <Box sx={{ width: "200px" }}>
      <Autocomplete
        options={customerOpt ?? []}
        disableClearable
        value={customerCode}
        onChange={async (event, v) => {
          const statusCode = await switchCustomer(v)
          if(statusCode === 200){
            //if(path[1]==="report") return
            navigate(`/${path[1]}/${pathName2}`)
          }
        }}
        sx={{ "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } }}
        renderInput={(params) => <StyledTextField label="Customer Code" {...params} />}
      />
    </Box>
  );
};

export default Navbar